import React, { useEffect } from 'react';
import './AttentionPage.css';
import { Link } from 'react-router-dom';
import { useAttention } from '../context/AttentionContext';
import { Button, EmptyState } from '../components/ui';
import TokenQuotaSummary from '../components/TokenQuotaSummary';

const reasons = {
  human_question: 'Ожидает вашего ответа', output_failed: 'Не удалось подготовить файл',
  output_review: 'Автоматическая проверка файла не завершена',
  output_attention: 'В файле есть замечания качества', session_failed: 'Исследование остановлено',
};

export function attentionLink(item) {
  if (item.action === 'answer_questions') return `/sessions/${item.session_id}/human-requests`;
  const session = `/projects/${item.project_id}/sessions/${item.session_id}`;
  return item.action === 'inspect_output' && item.output_id ? `${session}?output=${encodeURIComponent(item.output_id)}` : session;
}

export default function AttentionPage() {
  const { data, error, offset, setOffset, refresh } = useAttention();
  useEffect(() => { refresh(); }, [refresh]);
  return <div>
    <div className="page-header"><div><h1 className="page-title">Нужны мои действия</h1>
      <p className="page-subtitle">Вопросы и результаты ваших проектов, которым нужно внимание.</p></div></div>
    <TokenQuotaSummary />
    {error && <p role="alert" className="alert alert-error">Не удалось обновить очередь. {data && 'Показаны последние полученные данные. '}
      <Button onClick={() => refresh()}>Повторить</Button></p>}
    {!data && !error && <p role="status">Загрузка…</p>}
    {data?.total === 0 && <EmptyState title="Сейчас действий не требуется" icon="check">Новые вопросы и проблемы появятся здесь.</EmptyState>}
    <ul className="attention-list">
      {data?.items.map(item => <li key={item.session_id} className="card">
        <p className="text-muted">{item.project_title}</p><h2 className="card-title">{item.session_title}</h2>
        <p>{item.reasons.map(reason => reasons[reason]).filter(Boolean).join(' · ')}</p>
        {item.pending_question_count > 0 && <p>Вопросов: {item.pending_question_count}</p>}
        {item.affected_output_count > 0 && <p>Файлов, требующих внимания: {item.affected_output_count}</p>}
        <Link className="btn btn-primary" to={attentionLink(item)}>
          {item.action === 'answer_questions' ? 'Ответить' : item.action === 'inspect_output' ? 'Открыть файл' : 'Разобрать остановку'}
        </Link>
      </li>)}
    </ul>
    {data?.total > 50 && <div className="flex gap-2" aria-label="Страницы очереди">
      <Button disabled={!offset} onClick={() => setOffset(Math.max(0, offset - 50))}>Предыдущая</Button>
      <span>{offset + 1}–{Math.min(offset + 50, data.total)} из {data.total}</span>
      <Button disabled={offset + 50 >= data.total} onClick={() => setOffset(offset + 50)}>Следующая</Button>
    </div>}
  </div>;
}
